<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Edit Kondisi Bulk - Semua Merk Sesuai Jenis Barang</h5>
            </template>

            <b-form @submit.prevent="openModalConfirm">
                <div class="form-content-wrapper">
                    <h6 class="form-title">TIPE PINJAMAN</h6>
                    <b-form-group>
                        <b-form-select v-model="input.tipePinjaman" name="tipePinjaman" :options="optionTipePinjaman" value-field="id" text-field="name">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Pilih Tipe Pinjaman --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>

                    <h6 class="form-title">JENIS BARANG</h6>
                    <b-form-group>
                        <span v-if="input.tipePinjaman == null" class="text-muted">Pilih tipe pinjaman terlebih dahulu.</span>
                        <span v-else-if="optionJenisBarang.length == 0" class="text-muted">Tidak ada jenis barang untuk tipe pinjaman ini.</span>
                        <b-form-checkbox-group v-else class="checkbox-group" v-model="input.jenisBarang" name="jenisBarang">
                            <b-form-checkbox v-for="item in optionJenisBarang" v-bind:key="item.id" :value="item.id">
                                {{ item.name }}
                            </b-form-checkbox>
                        </b-form-checkbox-group>
                    </b-form-group>

                    <h6 class="form-title">KONDISI</h6>
                    <div>
                        <b-button variant="pgiBtn" class="mb-2" @click="addKondisi" name="kondisiAddBtn"><i class="fa fa-plus mr-2"></i>Kondisi</b-button>
                        <Kondisi v-for="item in input.kondisi" v-bind:key="item.index"
                            :kondisi="item" :length="input.kondisi.length" :isKendaraan="isKendaraan" @remove="removeKondisi(item.index, item.id)"
                        />
                    </div>
                </div>
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button type="submit" name="merkBarangUpdateBtn" variant="pgiBtn">Update</b-button>
                </div>
            </b-form>
        </b-card>
        <ModalConfirm id="modal-confirm-edit" title="Confirm Edit Kondisi Semua Merk" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah kondisi semua merk barang ini?" @submit="onSubmit" />
    </div>
</template>

<script>
import Spesifikasi from '../../../components/spesifikasi/Spesifikasi'
import Kondisi from '../../../components/kondisi/Kondisi'

export default {
    name: 'edit-kondisi-semua-merk',
    components: { 
        Kondisi
    },
    data(){
        return{
            initStatus: 0,
            isSubmitting: false,
            input:{
                tipePinjaman: null,
                kondisi: [],
                jenisBarang: []
            },
            indexKondisi: 0,
            deleteKondisi: [],
            optionTipePinjaman: [],
            optionJenisBarang: []
        }
    },
    computed: {
        // Field "Nama Sendiri" hanya untuk kendaraan, tipe pinjaman lain memakai field "Packing" (dus)
        isKendaraan() {
            return this.input.tipePinjaman === 2 // TODO HARDCODED JENIS PINJAMAN 2 (Kendaraan), sama dengan EnumJenisPinjaman.KENDARAAN
        }
    },
    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0

            this.$axios.get("tipe-pinjaman/selection").then(response => {
                this.optionTipePinjaman = response.data
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        getJenisBarang(tipePinjamanId) {
            this.optionJenisBarang = []
            this.input.jenisBarang = []

            if (tipePinjamanId == null) return

            this.$axios.get(`barang-jenis/jenis-pinjaman/${tipePinjamanId}`).then(response => {
                this.optionJenisBarang = response.data
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
        },

        //----------------- Fungsi Tambah Hapus Data Spesifikasi & Kondisi -----------------

        addKondisi() {
            this.input.kondisi.unshift({ 
                index: this.indexKondisi, 
                id: 0, 
                name: "", 
                dus: 0,
                namaSendiri: 0,
                keterangan: "",
                detailInfo: "persen",
                nominalPersen: null,
                nominalAngka: null,
                hargaMaksimal: 0
            })
            this.indexKondisi++;
        },

        removeKondisi(index, id) {
            this.input.kondisi = this.input.kondisi.filter(item => item.index != index)
            this.deleteKondisi.push(id)
        },


        //----------------- Fungsi Submit Data -----------------

        onSubmit(){
            var status = ""
            let payload = new FormData()

            //----------------- Append Data Jenis Barang -----------------

            for (var x of this.input.kondisi) {
                payload.append('kondisiId', x.id)
                payload.append('kondisiName', x.name)
                const nominalHargaMaks = this.$helper.removeThousandSeparator(x.hargaMaksimal);
                payload.append('kondisiHargaMaksimal', nominalHargaMaks)
                if (this.isKendaraan == false) {
                    if (x.dus == 0) {
                        status = true
                    } 
                    else {
                        status = false
                    }
                    payload.append('kondisiDus', status)
                } 
                else {
                    if (x.namaSendiri == 0) {
                        status = true
                    } 
                    else {
                        status = false
                    }
                    payload.append('kondisiNamaSendiri', status)
                }

                payload.append('kondisiKeterangan', x.keterangan)

                if (x.detailInfo == "nominal") {
                    let nominalAngka = this.$helper.removeThousandSeparator(x.nominalAngka);
                    payload.append('kondisiNominalAngka', nominalAngka)
                    payload.append('kondisiNominalPersen', null)
                } 
                else {
                    payload.append('kondisiNominalPersen', x.nominalPersen)
                    payload.append('kondisiNominalAngka', null)
                }
            }

            if (this.deleteKondisi != []) {
                for (var x of this.deleteKondisi) {
                    payload.append("deleteKondisiId", x)
                }
            }

            payload.append("jenisIds", this.input.jenisBarang)


            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true
            
            this.$axios.post("barang-merk/edit-all-merk-kondisi-by-jenis", payload).then(response => {
                this.$helper.setFlash(`Kondisi merk dari jenis barang-barang yang dipilih berhasil diubah!`)
                let path = this.$route.path.split("/")
                path.pop()
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },


        //----------------- Fungsi Lain -----------------

        openModalConfirm(){
            if (this.input.tipePinjaman == null) {
                this.$helper.toastErr(this, "Mohon pilih tipe pinjaman")
            } else if (this.input.kondisi.length == 0) {
                this.$helper.toastErr(this, "Mohon masukkan minimal 1 kondisi")
            } else if (this.input.jenisBarang.length == 0) {
                this.$helper.toastErr(this, "Mohon pilih minimal 1 jenis barang")
            }
            else this.$bvModal.show("modal-confirm-edit")
        }

    },

    watch: {
        'input.tipePinjaman': function(newVal) {
            this.getJenisBarang(newVal)
        }
    },

    created(){
        this.init()
    }
}
</script>
